import React, { useEffect, useState } from "react";
import { Button, Row, Col, Form, Input, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { postRequest } from "../../api";
import { componentStyles } from "../signin/SignInStyles";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import ClipLoader from "react-spinners/ClipLoader";
import Footer from "../../components/layout/Footer";
import ava1 from "../../assets/images/my-friend-logo-blue.svg";
import strings from "../../constants/constants";
import { AUTH_TOKEN } from "../../redux/constants/Auth";
import { components } from "@aws-amplify/ui-react";


const Signup = () => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [messageApi, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem(AUTH_TOKEN);
    if (authToken) {
      navigate("/landing-page");
    }
  }, [navigate]);

  const onSubmit = () => {
    form.validateFields().then(() => {
      signupRequest();
    });
  };

  const signupRequest = async () => {
    setLoader(true);
    try {
      const values = form.getFieldsValue();
      const response = await postRequest("/user/signup", values);
      setLoader(false);

      if (response.error || response.message) {
        messageApi.error({
          message: "Error",
          description: response.error
            ? `${response.error}`
            : `${response.message}`,
        });
      } else {
        localStorage.clear();
        messageApi.success({
          message: "Success",
          description: "Account created successfully!",
        });
        navigate('/confirm-email');
      }
    } catch (error) {
      messageApi.error({
        message: "Error",
        description: error.error ? error.error : error.message,
      });
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const emailRules = [
    { required: true, message: "Please input your email!" },
    { type: "email", message: "The input is not a valid email!" },
  ];

  const passwordRules = [
    { required: true, message: "Please input your password!" },
    {
      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/,
      message:
        "Password must contain at least 8 characters, including uppercase, lowercase, number, and special character.",
    },
  ];

  return (
    <div style={{ maxHeight: "100dvh", overflow: "hidden" }}>
      <Row
        style={componentStyles.outer}
      >
        <Col lg={12} md={16} xs={22}>
          <div
            style={componentStyles.outer}
          >
            <div
              style={componentStyles.inner}
            >
              <div
                style={componentStyles.marginAuto}
              >
                <img
                  style={componentStyles.logoinLogoStyle}
                  src={ava1}
                  alt="logo"
                />
              </div>
              <div
                style={componentStyles.marginAuto}
              >
                <span style={componentStyles.signInHeading}>Sign Up</span>
              </div>
              <div
                style={componentStyles.marginAuto}
              >
                <span style={componentStyles.signInDescription} level={5}>
                  Enter your details to create an account
                </span>
              </div>
              {contextHolder}
              <Form
                form={form}
                onFinish={onSubmit}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                style={componentStyles.formBody}

              >
              <Row style={componentStyles.flexCenter}>
                <Col className="pt-2" lg={16} md={16} xs={22}>  
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                            ...emailRules,
                            ...(process.env.REACT_APP_ENV === 'production'
                              ? [
                                  {
                                    validator: (_, value) => {
                                      if (value && /\+/.test(value)) {
                                        return Promise.reject(
                                          new Error("Email addresses with '+' are not allowed.")
                                        );
                                      }
                                      return Promise.resolve();
                                    },
                                  },
                                ]
                              : []),
                          ]}
                    style={componentStyles.formInput}
                  >
                    <Input placeholder="Email" maxLength={255} />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={componentStyles.flexCenter}>
                <Col className="pt-2" lg={16} md={16} xs={22}>  
                  <Form.Item
                    label="Password"
                    name="password"
                    rules={passwordRules}
                    style={componentStyles.formInput}
                  >
                    <Input.Password
                      placeholder="Password"
                      iconRender={(visible) =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
                <Form.Item
                  style={componentStyles.centerFormButton}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={componentStyles.signInButton}
                  >
                    {loader ? (
                      <ClipLoader
                        color="#fff"
                        loading={loader}
                        size={15}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <span>Sign Up</span>
                    )}
                  </Button>
                  <div class="text-center pt-2" style={componentStyles.SignupLink}>
                    Already have an account?{" "}
                    <a onClick={() => navigate("/signin")}>Login here</a>
                  </div>
                </Form.Item>
              </Form>
              <Row>
                <Col xs={24}>
                  <p style={componentStyles.privacyPolicyTextStyle}>
                    {strings.privacyPolicyText}
                    <a href={strings.privacyPolicyLink} target="_blank">
                      Privacy Policy
                    </a>
                  </p>
                  <p style={componentStyles.privacyPolicyTextStyle}>
                    {strings.helpSupportText}
                    <a href={strings.helpSupportLink} target="_blank">
                      Help & Support
                    </a>
                  </p>
                </Col>
              </Row>
            </div>

          </div>
        </Col>
      </Row>
      <Row style={componentStyles.fixFooter}>
        <Col xs={24}>
          <Footer />
        </Col>
      </Row>
    </div>
  );
};

export default Signup;